import { render, staticRenderFns } from "./ResponseType6.vue?vue&type=template&id=07f124bc&scoped=true&"
import script from "./ResponseType6.vue?vue&type=script&lang=js&"
export * from "./ResponseType6.vue?vue&type=script&lang=js&"
import style0 from "./ResponseType6.vue?vue&type=style&index=0&id=07f124bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f124bc",
  null
  
)

export default component.exports